'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MonacoDiffEditor = exports.default = undefined;

var _editor = require('./editor');

var _editor2 = _interopRequireDefault(_editor);

var _diff = require('./diff');

var _diff2 = _interopRequireDefault(_diff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _editor2.default;
exports.MonacoDiffEditor = _diff2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-monaco-editor/lib/index.js
// module id = 337
// module chunks = 76301927324276 205441848602771